import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activitySetup"},[_c(VApp,[_c(VContainer,[_c(VLayout,{staticStyle:{"padding-top":"20vh"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('center',[_c('div',{staticClass:"double-spinner",staticStyle:{"margin-right":"10px"}})])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }